import React from "react";
import { Switch as CoreSwitch } from "@jelly/ui";

import defaultStyle from "./Switch.module.scss";

export const Switch: React.FC<React.ComponentProps<typeof CoreSwitch>> = (props) => {
  return <CoreSwitch {...props} style={defaultStyle} />;
};
